export default __webpack_public_path__ + "static/media/18.a3fdaf6c.svg";